import React, { useState } from 'react';
import { SplitPanelUtil } from '../../commonUtils/SplitPanelUtil';
import {
  ICellData,
  pascalToCamelCase,
  statusRenderer,
  sequenceFilterUIProperties
} from '../onboardingUtils';
import { DataTable } from '@scuf/datatable';
import i18next from '../../../i18next';
import {  Icon, Input, Select, Tooltip } from '@scuf/common';
import {  timeZoneOptions } from './TimezoneData';
import DataProcessingModel from './DataProcessingModel';
import { check } from 'prettier';
import { ENode } from '../onboardingModels';

export interface IHBSSIRole
{
  isHBSOrg :boolean,
  isPortfolioManager :boolean,
  isOrganisationManager :boolean
}

interface IOrganisationPanelSummaryView {
  data: any;
  latitude: any;
  setlatitude: any;
  longitude: any;
  setlongitude: any;
  timeZone: any;
  setTimeZone: any;
  fieldUpdated: any;
  setFieldUpdated: any;
  latitudeTooltipErrorMsg: string;
  longitudeTooltipErrorMsg: string;
  hasNodeMetaDataUpdatePerm: boolean;
  currencyList : { text: string, value: string }[],
  currency:any,
  setCurrency:any,
  hbsSIRole: IHBSSIRole;
}

export const OrganisationPanelSummaryView = (
  props: IOrganisationPanelSummaryView
) => { 
  
  const invitationStatusRenderer = (cellData: ICellData) => {
    type colorType = 'red' | 'orange' | 'green' | 'blue' | 'grey';
    let color: colorType = 'grey';
    switch (cellData.value) {
      case 'EXPIRED':
      case 'CANCELED':
        color = 'red';
        break;
      case 'REGISTERED':
        color = 'green';
        break;
      case 'SENT':
        color = 'blue';
        break;

      default:
    }

    return (
      <span>
        <DataTable.Status color={color} />
        {cellData.value}
      </span>
    );
  };
  // const [tooltipErrorMsg, settooltipErrorMsg] = useState("");  

  // const filterNonUIProperties = (data: Array<any>) => {
  //   const fieldToRemove = [
  //     'childCount',
  //     'childNodes',
  //     'externalId',
  //     'id',
  //     'logoUri',
  //     'metadata',
  //     'parent',
  //     'parentId',
  //     'ExternalIds',
  //     'rootNodeId',
  //     'ModelId',
  //     'SiteLatitude',
  //     'SiteLongitude',
  //     'CustomerId'
  //   ];
  //   return data.filter(datum => !fieldToRemove.includes(datum));
  // };

  let fieldError = props.latitudeTooltipErrorMsg ? " " : ""
  return (
    <>
      {sequenceFilterUIProperties(Object.keys(props.data)).map((dataKey, index) => {
        const value = props.data[dataKey];
        let isEditable = false;
        let hasSelectBox = false;
        if (dataKey === 'timeZone') {
          isEditable = true;
          hasSelectBox = true;
        } 
        if (dataKey === 'latitudeAndLongitude') {
          isEditable = true;
          hasSelectBox = false;
        }
        if (dataKey === 'currency') {
          isEditable = true;
          hasSelectBox = true;
            if (!(props?.data?.orgType?.toLowerCase() == "customer") || (!props.hbsSIRole.isPortfolioManager && !props.hbsSIRole.isOrganisationManager)) {
            return null;
            }
        }
        // New change suggested by HUE, any field which doesnot have value, not to show that
        if(value)
        {return (
           <React.Fragment key={index + dataKey}>
             {dataKey !== 'nodeId' ? (
               <SplitPanelUtil.PanelListItem
                 name={i18next.t(dataKey)}
                 // value={Object.values(props.organisation)[index]}
                 valueRenderer={() =>
                   props.hasNodeMetaDataUpdatePerm && isEditable ? (
                     hasSelectBox ? (
                       <>
                        {dataKey === 'timeZone' && (
                         <Select
                           options={timeZoneOptions}
                           search={true}
                           value={props.timeZone}
                           onChange={(data: any) => {
                             if (data !== props.timeZone) {
                               props.setTimeZone(data);
                               if (
                                 props.fieldUpdated.includes(dataKey) === false
                               ) {
                                 props.setFieldUpdated(
                                   (oldDataKeyArray: any) => [
                                     ...oldDataKeyArray,
                                     dataKey
                                   ]
                                 );
                               }
                             }
                           }}
                         />)
                          }
                          {(dataKey === 'currency' && ( props.hbsSIRole.isPortfolioManager || props.hbsSIRole.isOrganisationManager)) &&( <Select
                           options={props.currencyList}
                           search={true}
                           value={props.currency}
                           onChange={(data: any) => {
                              if (data !== props.currency) {
                                props.setCurrency(data);
                                if (
                                  props.fieldUpdated.includes(dataKey) === false
                                ) {
                                  props.setFieldUpdated(
                                    (oldDataKeyArray: any) => [
                                      ...oldDataKeyArray,
                                      dataKey
                                    ]
                                  );
                                }
                              }
                            }}
                         />)}
                       </>
                     ) : (
                       <>
                         <div className="wrap-input-box-err-msg">
                           <div className="input-boxes-wrap">
                             <Input
                               value={props.latitude}
                               onChange={(data: any) => {
                                 if (data !== props.latitude) {
                                   props.setlatitude(data);
                                   if (
                                     props.fieldUpdated.includes('latitude') ===
                                     false
                                   ) {
                                     props.setFieldUpdated(
                                       (oldDataKeyArray: any) => [
                                         ...oldDataKeyArray,
                                         'latitude'
                                       ]
                                     );
                                   }
                                 }
                               }}
                               error={props.latitudeTooltipErrorMsg ? ' ' : ''}
                               type="number"
                             />
                             <Input
                               value={props.longitude}
                               onChange={(data: any) => {
                                 if (data !== props.longitude) {
                                   props.setlongitude(data);
                                   if (
                                     props.fieldUpdated.includes(
                                       'longitude'
                                     ) === false
                                   ) {
                                     props.setFieldUpdated(
                                       (oldDataKeyArray: any) => [
                                         ...oldDataKeyArray,
                                         'longitude'
                                       ]
                                     );
                                   }
                                 }
                               }}
                               error={props.longitudeTooltipErrorMsg ? ' ' : ''}
                               type="number"
                             />
                           </div>
                           {props.latitudeTooltipErrorMsg ||
                           props.longitudeTooltipErrorMsg ? (
                             <div className="error-helper-wrap">
                               <span className="error-label">
                                 {i18next.t('geoCordinatesErrorMsg')}
                               </span>
                               <Tooltip
                                 element={
                                   <Icon name="badge-info" root="building" />
                                 }
                                 position="bottom right"
                                 content={
                                   props.latitudeTooltipErrorMsg
                                     ? props.latitudeTooltipErrorMsg
                                     : props.longitudeTooltipErrorMsg
                                 }
                                 size="mini"
                               />
                             </div>
                           ) : null}
                         </div>
                       </>
                     )
                   ) : (
                     <>
                       {statusRenderer(value ? value.toString() : '---')}
                       {value ? value.toString() : '---'}
                     </>
                   )
                 }
               />
             ) : null}
           </React.Fragment>
         );}
      })}
   
    </>
  );
};

export default OrganisationPanelSummaryView;
